import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { PayCheckout } from "@/components/PayCheckout";
import { Loader2 } from "lucide-react";

/** A student's personal fee page — the same checkout as in class, but with its
 *  own address so it survives the class and works on a parent's phone. */
export default function PayPage() {
  const { id } = useParams();
  const [pay, setPay] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    document.title = "Pay your fees · Udyog Classes";
    api
      .get(`/pay/${id}`)
      .then(({ data }) => setPay(data))
      .catch(() => setErr("This payment link is not valid any more."));
  }, [id]);

  if (err)
    return (
      <div className="min-h-screen grid place-items-center bg-[#050505] text-white/60 text-[13px] px-6 text-center">
        {err}
      </div>
    );

  if (!pay)
    return (
      <div className="min-h-screen grid place-items-center bg-[#050505]">
        <Loader2 className="w-5 h-5 animate-spin text-white/30" />
      </div>
    );

  if (pay.paid)
    return (
      <div className="min-h-screen grid place-items-center bg-[#050505] px-6">
        <div className="text-center" data-testid="pay-page-paid">
          <div className="font-display text-3xl font-extrabold text-emerald-300">Payment confirmed</div>
          <div className="text-[13px] text-white/50 mt-2">
            Seat #{pay.seat_no} is yours, {pay.user_name}. We'll send the group link on WhatsApp.
          </div>
        </div>
      </div>
    );

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="pay-page">
      <PayCheckout
        open
        onClose={() => {}}
        roomName={pay.room_name}
        userName={pay.user_name}
        whatsapp={null}
        classTitle={pay.class_title}
      />
    </div>
  );
}
